import type {
  ChatFlowFormToFillItem,
  ChatFlowProfileSectionItem,
  ChatFlowResponse,
} from '../../../../../services/chatFlowApi';

function formHasCompletedRound(form: ChatFlowFormToFillItem): boolean {
  return (form.roundsBySubmission ?? []).some((r) => r.status === 'completed');
}

function profileSectionNeedsReview(section: ChatFlowProfileSectionItem): boolean {
  return section.status === 'completed' || section.status === 'final_confirm';
}

export type FillingRoadmapState = {
  loading: boolean;
  /** Forms the employee marked completed (empdoc_forms_to_fill). */
  completed: number;
  /** Forms on the invitation (invitation_forms_to_fill). */
  total: number;
  /** Admin-reviewed completed forms + profile sections (for step-2 save button). */
  reviewed: number;
};

export function fillingRoadmapFromChatFlow(res: ChatFlowResponse | null): FillingRoadmapState {
  const list = res?.formsToFill ?? [];
  const profileSections = res?.profileSections ?? [];
  const total =
    typeof res?.formsToFillTotal === 'number' && res.formsToFillTotal >= 0
      ? res.formsToFillTotal
      : list.length;
  const completed =
    typeof res?.formsToFillCompleted === 'number' && res.formsToFillCompleted >= 0
      ? res.formsToFillCompleted
      : list.filter((f) => f.status === 'completed').length;
  const withRounds = list.filter(formHasCompletedRound);
  const formsReviewed = withRounds.filter(
    (f) => f.adminApproved === true || f.adminApproved === false
  ).length;
  const profileReviewed = profileSections
    .filter(profileSectionNeedsReview)
    .filter((s) => s.adminApproved === true || s.adminApproved === false).length;
  return { loading: false, completed, total, reviewed: formsReviewed + profileReviewed };
}

export { profileSectionNeedsReview, formHasCompletedRound };
